module.exports = __webpack_public_path__ + "img/icon-transfer-funds.d604de75.svg";